import React from "react";
import { Button, ButtonGroup, Col, Row } from "react-bootstrap";
import { labels } from "../../../localization/labels";
import { messages } from "../../../localization/messages";

const ErrorBoundary = props => (
  <div className="err_page">
    <Row className="d-flex justify-content-center">
      <Col>
        <h1>
          <dt>{messages.error_oops}</dt>
        </h1>
      </Col>
    </Row>
    <Row className="d-flex justify-content-center">
      <Col>
        <h3>{messages.error_default}</h3>
      </Col>
    </Row>
    <Row className="d-flex justify-content-center">
      <Col>
        <h3>{messages.error_options}</h3>
      </Col>
    </Row>
    <Row className="d-flex justify-content-center">
      <Col>
        <ButtonGroup className="button_group" vertical size="lg">
          <Button
            className="mb-2"
            variant="secondary"
            onClick={props.goToHomePage}
          >
            {labels.backToHome}
          </Button>
          <Button className="mb-2" variant="info" onClick={props.refreshPage}>
            {labels.refreshPage}
          </Button>
          <Button className="mb-2" variant="warning" onClick={props.goToC2S2}>
            {labels.reportToC2S2}
          </Button>
        </ButtonGroup>
      </Col>
    </Row>
  </div>
);

export default ErrorBoundary;
